// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"e10d40db","213":"fb8c9f42","220":"5897a30e","457":"fffe2142","534":"5281c425","575":"97dce461","656":"0f0a32b1","738":"527aca8c","891":"00119227","930":"6f6cf5b4"}[chunkId] + ".chunk.js";
};